import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';

const PageSection = styled.section`
  padding: 100px 0;
  
  h1 {
    margin-bottom: 40px;
    font-weight: 700;
    color: #333;
    
    span {
      color: #2e7d32;
    }
  }
  
  h2 {
    font-size: 1.5rem;
    color: #2e7d32;
    margin: 30px 0 15px;
    font-weight: 600;
  }
  
  p {
    color: #555;
    margin-bottom: 20px;
    line-height: 1.7;
  }
  
  ul {
    margin-bottom: 25px;
    
    li {
      margin-bottom: 10px;
      color: #555;
    }
  }
  
  .last-updated {
    font-style: italic;
    color: #777;
    margin-bottom: 30px;
  }
`;

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = 'Privacy Policy | Bering Solutions';
  }, []);
  
  return (
    <PageSection>
      <Container>
        <h1>Privacy <span>Policy</span></h1>
        <p className="last-updated">Last Updated: May 30, 2025</p>
        
        <p>
          Bering Solutions LLC ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by Bering Solutions LLC.
        </p>
        <p>
          This Privacy Policy applies to our website, beringsolutions.com, and its associated subdomains (collectively, our "Service"). By accessing or using our Service, you signify that you have read, understood, and agree to our collection, storage, use, and disclosure of your personal information as described in this Privacy Policy.
        </p>
        
        <h2>Information We Collect</h2>
        <p>
          We collect information from you when you voluntarily provide it to us. This may include:
        </p>
        <ul>
          <li><strong>Personal Information:</strong> When you complete our contact form or request a cash offer, we may collect your name, email address, phone number, and information about your property.</li>
          <li><strong>Property Information:</strong> Details about your land such as location, size, and any additional information you provide about the property.</li>
          <li><strong>Device Information:</strong> We may collect information about your device, including IP address, browser type, and operating system to improve our service and for security purposes.</li>
        </ul>
        
        <h2>How We Use Your Information</h2>
        <p>
          We use the information we collect for various purposes, including:
        </p>
        <ul>
          <li>To provide and maintain our Service</li>
          <li>To respond to your inquiries and provide customer support</li>
          <li>To evaluate properties and provide cash offers</li>
          <li>To communicate with you about our services, offers, and updates</li>
          <li>To improve our website and customer experience</li>
          <li>To protect against fraud and unauthorized transactions</li>
          <li>To comply with legal obligations</li>
        </ul>
        
        <h2>Cookies and Tracking Technologies</h2>
        <p>
          We use cookies and similar tracking technologies to track activity on our Service and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
        </p>
        
        <h2>Information Sharing and Disclosure</h2>
        <p>
          We may share your information in the following situations:
        </p>
        <ul>
          <li><strong>With Service Providers:</strong> We may share your information with third-party vendors, service providers, and other contractors who perform services for us.</li>
          <li><strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred as part of that transaction.</li>
          <li><strong>Legal Requirements:</strong> We may disclose your information where required to do so by law or in response to valid requests by public authorities.</li>
          <li><strong>With Your Consent:</strong> We may share your information with your consent or as otherwise disclosed at the time of collection.</li>
        </ul>
        
        <h2>Data Security</h2>
        <p>
          We implement reasonable precautions to protect your information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee absolute security.
        </p>
        
        <h2>Your Rights</h2>
        <p>
          Depending on your location, you may have certain rights regarding your personal information, such as:
        </p>
        <ul>
          <li>The right to access personal information we hold about you</li>
          <li>The right to request correction of inaccurate information</li>
          <li>The right to request deletion of your information</li>
          <li>The right to opt-out of marketing communications</li>
        </ul>
        <p>
          To exercise these rights, please contact us using the information provided below.
        </p>
        
        <h2>Children's Privacy</h2>
        <p>
          Our Service is not directed to children under the age of 18, and we do not knowingly collect personal information from children under 18. If we learn we have collected or received personal information from a child under 18, we will delete that information.
        </p>
        
        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
        </p>
        
        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us:
        </p>
        <p>
          Bering Solutions LLC<br />
          14 NE 1st Ave Ste 1403 #140<br />
          Miami, FL 33132<br />
          Email: connect@beringsolutions.com<br />
          Phone: 786-460-6046
        </p>
      </Container>
    </PageSection>
  );
};

export default PrivacyPolicy;
